import {useState} from 'react';
import RegionAuto from './RegionAuto';
import CountryAuto from './CountryAuto';
import { createUser } from '../../service/subscribers/subscribersApi';
import { isValidEmail } from "../utils/isValidEmail";
import ModalWindow from "../components/ModalWindow";

const Modal = (props) => {
    const {domain, regions, fetchList, pageNumber} = props;
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');

    const [modal, setModal] = useState(false);
    const [errModal, setErrModal] = useState(false)

    const setStatus = () => {
        setModal(!modal);
        document.body.style.overflow = !modal ? "hidden" : "auto";
    }
    const nameChange = (event) => {
        setName(event.target.value)
    };
    const surnameChange = (event) => {
        setSurname(event.target.value)
    }
    const emailChange = (event) => {
        setEmail(event.target.value);
    }
    const phonesChange = (event) => {
        setPhone(event.target.value);
    }

    const [country, setCountry] = useState('');
    const [region, setRegion] = useState('');

    const fetchAddOp = async () => {
        const requestBody = {
            email: isValidEmail(email) ? email : null,
	        phone: phone,
	        name: name,
	        surname: surname,
	        region_id: region,
	        country: country,
	        timezone: "UTC"
        }
        try {
            await createUser(requestBody);
            fetchList();
            setStatus();
        }catch (err) {
            console.error(err);
        }
    }

    const request = () => {
        if (
            name !== '' && 
            surname !== '' &&
            phone !== '' && region !== null && country !== ''
        ){  
            fetchAddOp();
        } else{
            setErrModal(true)
        }
    }
    
    const close = () => {
        setStatus();
    }

    return(
        <div>
            <button className='requestBtn' onClick={setStatus}>Add new user</button>
            {modal && <ModalWindow>
                <div className='modal-box'> 
                    <div className='input-areas'>
                      <label>Name</label>
                      <input className='inputs' type='text' onChange={nameChange}/>
                    </div>
                    <div className='input-areas'>
                      <label>Surname</label>
                      <input className='inputs' type='text' onChange={surnameChange}/>
                    </div>
                    <div className='input-areas'>
                      <label>Email</label>
                      <input className='inputs' type='text' onChange={emailChange} />
                    </div>
                    <div className='input-areas'>
                      <label>Phone</label>
                      <input className='inputs' type='text' onChange={phonesChange}/>
                    </div>
                    <CountryAuto setType={setCountry}/>
                    <RegionAuto regions={regions} setType={setRegion}/>
                    <div className='modal-btns'>
                        <button className='requestBtn' onClick={request}>Save</button>
                        <button className='closeBtn' onClick={close}>Cancel</button>
                    </div>
                </div>
            </ModalWindow>}
        </div>
    )
}


export default Modal